var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"actions-container",class:_vm.categoryName},[_c('div',{staticClass:"action-container"},_vm._l((_vm.actions),function(action,index){return _c('action',_vm._b({key:index},'action',action,false))}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }